// TODO: move this to plugins

export default class PromiseQueue {
  constructor({ debug = false, interval = 1000, link = false } = {}) {
    this.counter = 0;
    this.linkQueueMap = {};
    this.errors = {};
    this.queue = [];
    this.debug = debug;
    this.link = link;
    this.queueTimeout = null;
    this.queueTimeoutInterval = interval;
    this.intervalTimer = null;
    this.success = new Set();
    return this;
  }

  enqueue(promiseFunc, linkId = null) {
    if (typeof promiseFunc !== "function") {
      throw "Only function parameter is allowed.";
    }

    // for tracing purpose
    ++this.counter;
    const itemId = this.counter;

    if (linkId) {
      this.linkQueueMap[itemId] = linkId;
    }

    this.queue.push({
      id: itemId,
      func: promiseFunc,
    });

    if (this.debug) {
      logger.debug(`[promiseQueue] enqueue itemId=${itemId}`);
    }

    return itemId;
  }

  dequeue() {
    if (this.queue.length) {
      const itemId = this.queue[0].id;
      const linkId = this.linkQueueMap[itemId];

      const resultPromise = this.queue[0].func();
      if (resultPromise && resultPromise.then) {
        resultPromise.then(
          () => {
            this.queue.shift();
            if (this.link) {
              this.success.add(linkId);
            }
            if (this.debug) {
              logger.debug(
                `[promiseQueue] processed itemId=${itemId}, left ${this.queue.length}, promise resolve`,
              );
            }

            this.dequeue();
          },
          (error) => {
            if (this.link) {
              // stop executions if errors occur for linked queue
              this.stop();
              if (this.success.has(linkId)) {
                this.success.delete(linkId);
              }
            } else {
              this.queue.shift();
            }
            if (this.debug) {
              logger.debug(
                `[promiseQueue] processed itemId=${itemId}, left ${this.queue.length}, promise reject`,
              );
            }

            if (this.link && Object.keys(this.linkQueueMap).length !== 0) {
              // remove unexecute linked promise from execution queue
              const matchedItems = Object.keys(this.linkQueueMap).filter((key) => {
                return this.linkQueueMap[key] === linkId;
              });
              this.queue = this.queue.filter((q) => !matchedItems.includes(q.id.toString()));
            }
            this.errors[itemId] = error;
            this.dequeue();
          },
        );
      } else {
        this.queue.shift();
        if (this.debug) {
          logger.debug(`[promiseQueue] processed itemId=${itemId}, left ${this.queue.length}`);
        }
        this.dequeue();
      }
    } else {
      this.queueTimeout = setTimeout(
        function () {
          if (this.debug) {
            logger.debug(
              `[promiseQueue] queue is empty, check again in ${
                this.queueTimeoutInterval / 1000
              } sec`,
            );
          }

          this.dequeue();
        }.bind(this),
        this.queueTimeoutInterval,
      );
    }
  }

  start() {
    return new Promise((resolve) => {
      if (this.debug) {
        logger.debug("[promiseQueue] start");
      }
      clearTimeout(this.queueTimeout);
      this.dequeue();

      // resolve if all queue executed by checking queue list
      this.intervalTimer = setInterval(() => {
        if (this.queue.length === 0) {
          clearInterval(this.intervalTimer);
          resolve();
        }
      }, 1000);
    });
  }

  stop() {
    this.queue = [];
  }

  debug(toggle) {
    this.debug = toggle;
  }

  hasError() {
    return Object.keys(this.errors).length > 0;
  }

  get size() {
    return this.queue.length;
  }
}
